"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { LuRemoveFormatting } from "react-icons/lu";
import { Button } from "@/components/ui";
export function ClearFormattingButton() {
  const $ = _c(5);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = () => {
      editor?.chain().focus().unsetAllMarks().clearNodes().run();
      trackEmailComposerAction("clear_formatting_clicked", "toolbar");
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuRemoveFormatting size={16} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" onClick={t0} tooltip="Clear formatting">{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}